import { Link } from "react-router-dom";
import { Facebook, Instagram, Linkedin } from "lucide-react";
import { useLang } from "@/i18n/LangContext";

export default function Footer() {
  const { t, link } = useLang();
  return (
    <footer data-testid="site-footer" className="bg-ink border-t border-white/10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 lg:py-20">
        <div className="grid gap-12 md:grid-cols-2 lg:grid-cols-4">
          <div>
            <div className="flex items-center gap-3">
              <img src="/favicon.svg" alt="" className="h-9 w-9" width="36" height="36" />
              <div className="leading-none">
                <p className="font-display font-extrabold tracking-tight text-[15px]">{t("brand")}</p>
                <p className="text-[8.5px] tracking-[0.26em] text-steel mt-1.5">{t("footer.line").toUpperCase()}</p>
              </div>
            </div>
            <p className="mt-6 text-sm text-steel leading-relaxed max-w-xs">«{t("tagline")}»</p>
            <div className="mt-6 space-y-2 text-sm text-steel" data-testid="footer-contact">
              <p>{t("contactPage.address")}, {t("contactPage.city")}</p>
              <p><a href="tel:+306989164257" data-testid="footer-phone" className="hover:text-electric transition-colors">{t("contactPage.phone")}</a></p>
              <p><a href="mailto:info@digital-company.gr" data-testid="footer-email" className="hover:text-electric transition-colors">info@digital-company.gr</a></p>
            </div>
            <div className="mt-6 flex items-center gap-3 text-steel">
              <span className="p-2 rounded-full border border-white/10" role="img" aria-label="Facebook"><Facebook className="h-4 w-4" /></span>
              <span className="p-2 rounded-full border border-white/10" role="img" aria-label="Instagram"><Instagram className="h-4 w-4" /></span>
              <span className="p-2 rounded-full border border-white/10" role="img" aria-label="LinkedIn"><Linkedin className="h-4 w-4" /></span>
            </div>
          </div>

          <div>
            <h3 className="text-[11px] font-semibold tracking-[0.25em] text-steel">{t("footer.servicesTitle")}</h3>
            <ul className="mt-5 space-y-3">
              {t("footer.services").map((s, i) => (
                <li key={i}><Link to={link(s.to)} className="text-sm text-white/70 hover:text-electric transition-colors">{s.label}</Link></li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-[11px] font-semibold tracking-[0.25em] text-steel">{t("footer.companyTitle")}</h3>
            <ul className="mt-5 space-y-3">
              {t("footer.company").map((s, i) => (
                <li key={i}><Link to={link(s.to)} className="text-sm text-white/70 hover:text-electric transition-colors">{s.label}</Link></li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-[11px] font-semibold tracking-[0.25em] text-steel">{t("footer.legalTitle")}</h3>
            <ul className="mt-5 space-y-3">
              {t("footer.legal").map((s, i) => (
                <li key={i}><Link to={link(s.to)} className="text-sm text-white/70 hover:text-electric transition-colors">{s.label}</Link></li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-14 pt-8 border-t border-white/10 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
          <p className="text-xs text-steel">{t("footer.rights")}</p>
          <p className="text-[10px] tracking-[0.3em] text-steel/60">DIGITALCOMPANY.GR</p>
        </div>
      </div>
    </footer>
  );
}
